import {UserModel} from 'app/modules/auth'
import clsx from 'clsx'
import {hasPermission} from 'common/HelperFunctions'
import {HeaderMessagesMenu, HeaderNotificationsMenu, HeaderUserMenu} from 'common/partials'
import {shallowEqual, useSelector} from 'react-redux'
import {Link} from 'react-router'
import {NotificationReducer, RootState} from 'setup'

import {KTIcon, toAbsoluteUrl} from '_metronic/helpers'
import {useLayout} from '_metronic/layout/core'
import {ThemeModeSwitcher} from '_metronic/partials'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

const Navbar = () => {
  const {config} = useLayout()

  const user: UserModel = useSelector<RootState>(
    ({userReducer}) => userReducer.user,
    shallowEqual
  ) as UserModel
  const impersonation: any = useSelector<RootState>(
    ({userReducer}) => userReducer.impersonation,
    shallowEqual
  )

  const notificationsReducer = useSelector<RootState>(
    ({notificationsReducer}) => notificationsReducer,
    shallowEqual
  ) as NotificationReducer

  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div> */}

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
      </div> */}

      {/* NOTIFICATIONS */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={clsx('position-relative', btnClass)}
        >
          {notificationsReducer.notificationsCount > 0 && (
            <span className='badge badge-sm badge-circle badge-light-success position-absolute top-0 end-0'>
              {notificationsReducer.notificationsCount}
            </span>
          )}
          <i className='fa fa-bell' style={{fontSize: '20px'}} />
        </div>
        <HeaderNotificationsMenu />
      </div>

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTIcon iconName='element-plus' className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div> */}

      {/* GENERAL SETTINGS */}
      {hasPermission('user_manager_settings') && (
        <div className={clsx('app-navbar-item', itemClass)}>
          <Link
            to={'/institute/general-settings/settings'}
            className='btn btn-icon text-muted btn-active-light-primary btn-custom'
          >
            <i className='fa fa-gear' style={{fontSize: '20px'}} />
          </Link>
        </div>
      )}

      {/* Messages */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={clsx('position-relative', btnClass)}
        >
          <KTIcon iconName='message-text-2' className={btnIconClass} />
        </div>
        <HeaderMessagesMenu />
      </div>

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          {/* <img src={toAbsoluteUrl('media/avatars/300-3.jpg')} alt='' /> */}
          <img
            src={user.profilePicture ?? toAbsoluteUrl('/media/avatars/blank.png')}
            alt='profile'
            className={clsx({'border border-primary': !!impersonation})}
          />
        </div>
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export {Navbar}
